/**
 * Module dependencies.
 */

import { JSX, ReactNode } from 'react';
import { MenuItemWrapper } from './menu-item.style';

/**
 * `Props` type.
 */

type Props = {
  children?: ReactNode;
};

/**
 * Export `MenuItem` component.
 */

export function MenuItem({ children }: Props): JSX.Element {
  return (
    <MenuItemWrapper
      sx={{
        '&:hover': {
          backgroundColor: '#0E1824',
          opacity: 1,
        },
      }}
      variant={'text'}
    >
      {children}
    </MenuItemWrapper>
  );
}
